<template>
  <v-content class="content">
    <v-layout justify-center align-center style="min-height: 100vh">
      <v-card class="content-container" style="content-container">
        <v-progress-circular
          indeterminate
          size="50"
          class="primary--text ma-5"
        />

        <v-card-text> Processing. Please wait... </v-card-text>
      </v-card>
    </v-layout>
  </v-content>
</template>

<script>
import API from '@/api';
import UtilsMixins from '@/mixins/UtilsMixins';

export default {
  name: 'ProcessPayment',

  mixins: [UtilsMixins],

  data() {
    return {};
  },

  methods: {
    async verifyCheckoutSession() {
      let verified = false;

      while (!verified) {
        try {
          const response = await API.taxReturn.verifyCheckoutSession({
            id: this.$route.params.id,
            companyId: this.$route.query.companyId,
          });

          const paymentStatus = response.data.payment_status;

          if (paymentStatus === 'paid' || paymentStatus === 'pending') {
            this.$router.push(response.data.redirect_url);
            verified = true;
          }
        } catch (error) {
          console.error(error);
        } finally {
          await this.sleep(1000);
        }
      }
    },
  },

  async created() {
    this.verifyCheckoutSession();
  },
};
</script>

<style lang="css" scoped>
.content-container {
  width: 400px;
}
</style>
